import { createSelector } from 'reselect';

import { TState } from '~/src/store';
import { IAddress } from '~/src/store/reducers/auth';

export const selectClientPersonal = (state: TState) => {
    return state.auth.clientPersonal;
};

interface IAgreementInfoMenu {
    agreement: string,
    address: string,
}

export const formatPartOfAddress = (part: string | number, prefix: string, postfix = ','): string | undefined => {
    return part ? `${prefix} ${part}${postfix}` : undefined;
};

export const formatAddressIntoString = (address: IAddress): string => (
     [
        address.city,
        formatPartOfAddress(address.street, '\nул.'),
        formatPartOfAddress(address.house, '\nд.', address.building ? '' : ','),
        formatPartOfAddress(address.building, '/'),
        formatPartOfAddress(address.flat, 'кв.', ''),
    ]
        .filter(item => !!item)
        .join(' ')
);

export const selectClientPersonalForHeader = createSelector(
    selectClientPersonal,
    (personal): IAgreementInfoMenu | null => {
        if (!personal) {
            return null;
        }
        const { address, agreement } = personal;
        return {
            agreement: `${agreement}`,
            address: formatAddressIntoString(address),
        };
    },
);

